import { useLocation } from 'react-router-dom';

// Keep the exact search, collection and page when returning from a document.
export function useCatalogNavigation(itemType = '') {
  const location = useLocation();
  const candidate = location.pathname === '/' ? `/${location.search}` : location.state?.catalogUrl;
  const catalogUrl = typeof candidate === 'string' && (candidate === '/' || candidate.startsWith('/?'))
    ? candidate : itemType ? `/?itemType=${itemType}` : '/';
  return { catalogUrl, state: { catalogUrl } };
}
